<div class="w-full overflow-y-auto h-full">
    <div class="w-full p-6">
        <!-- Histórico de Pagamentos -->
        <div class="w-full py-6">
            <div class="flex w-full">
                <div class="p-2 rounded-xl bg-blue-100 ml-2 h-[40px]">
                    <mat-icon svgIcon="mat_solid:receipt_long" class="icon-size-6 text-blue-600"></mat-icon>
                </div>
                <div class="px-3">
                    <div class="w-full leading-10">
                        <span class="text-[17px] font-[500] font-remote">Faturas e Pagamentos</span>
                    </div>
                </div>
            </div>

            <div class="w-full p-4 space-y-3">
                <!-- Loading Skeleton -->
                <ng-container *ngIf="loading">
                    <div *ngFor="let _ of [1, 2, 3]" class="p-4 border border-gray-200 rounded-xl">
                        <div class="flex justify-between items-start">
                            <div class="flex items-start gap-3">
                                <div class="w-10 h-10 bg-gray-200 rounded-lg animate-pulse"></div>
                                <div>
                                    <div class="flex items-center gap-2 mb-2">
                                        <div class="h-4 bg-gray-200 rounded-xl w-28 animate-pulse"></div>
                                        <div class="h-4 bg-gray-200 rounded-full w-14 animate-pulse"></div>
                                    </div>
                                    <div class="h-3 bg-gray-200 rounded-xl w-32 animate-pulse mb-1"></div>
                                    <div class="h-3 bg-gray-200 rounded-xl w-24 animate-pulse"></div>
                                </div>
                            </div>
                            <div class="text-right">
                                <div class="h-5 bg-gray-200 rounded-xl w-20 animate-pulse mb-2"></div>
                                <div class="h-6 bg-gray-200 rounded-lg w-24 animate-pulse"></div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Empty State -->
                <div *ngIf="!loading && charges.length === 0" class="text-center py-8">
                    <mat-icon class="icon-size-12 text-gray-300" [svgIcon]="'mat_solid:receipt_long'"></mat-icon>
                    <p class="text-gray-500 font-inter text-[14px] mt-2">Nenhuma fatura encontrada</p>
                </div>

                <!-- Charges List -->
                <ng-container *ngIf="!loading">
                    <div *ngFor="let charge of charges"
                         class="p-4 border rounded-xl transition-colors"
                         [ngClass]="{
                            'border-gray-200 hover:bg-gray-50': charge.status === 'succeeded',
                            'border-yellow-200 bg-yellow-50': charge.status === 'pending',
                            'border-red-200 bg-red-50': charge.status === 'failed'
                         }">
                        <div class="flex justify-between items-start">
                            <div class="flex items-start gap-3">
                                <div class="p-2 rounded-lg"
                                     [ngClass]="{
                                        'bg-green-50': charge.status === 'succeeded',
                                        'bg-yellow-100': charge.status === 'pending',
                                        'bg-red-100': charge.status === 'failed'
                                     }">
                                    <mat-icon class="icon-size-6"
                                              [ngClass]="{
                                                'text-green-600': charge.status === 'succeeded',
                                                'text-yellow-600': charge.status === 'pending',
                                                'text-red-600': charge.status === 'failed'
                                              }"
                                              [svgIcon]="charge.status === 'succeeded' ? 'mat_solid:check_circle' :
                                                         charge.status === 'pending' ? 'mat_solid:pending' :
                                                         'mat_solid:error'"></mat-icon>
                                </div>
                                <div class="flex-1">
                                    <div class="flex items-center gap-2 mb-1">
                                        <span class="text-[15px] font-inter font-[500] text-gray-900">{{ charge.description }}</span>
                                        <span class="px-2 py-0.5 rounded-full text-[11px] font-inter font-[500]"
                                              [ngClass]="{
                                                'bg-green-100 text-green-700': charge.status === 'succeeded',
                                                'bg-yellow-200 text-yellow-800': charge.status === 'pending',
                                                'bg-red-100 text-red-700': charge.status === 'failed'
                                              }">
                                            {{ charge.status === 'succeeded' ? 'Pago' :
                                               charge.status === 'pending' ? 'Pendente' : 'Falhou' }}
                                        </span>
                                        <span *ngIf="charge.refunded" class="px-2 py-0.5 rounded-full text-[11px] font-inter font-[500] bg-gray-100 text-gray-700">
                                            Reembolsado
                                        </span>
                                    </div>
                                    <span class="text-[13px] font-inter font-[400] text-gray-500 block">
                                        {{ charge.created }}
                                    </span>
                                    <span *ngIf="charge.payment_method_details"
                                          class="text-[13px] font-inter font-[400] text-gray-500">
                                        {{ charge.payment_method_details }}
                                    </span>
                                </div>
                            </div>
                            <div class="text-right">
                                <span class="text-[16px] font-inter font-[600] text-gray-900 block">
                                    {{ formatCurrency(charge.amount) }}
                                </span>
                                <!-- Botão Baixar Recibo para pagamentos bem-sucedidos -->
                                <a *ngIf="charge.status === 'succeeded' && charge.receipt_pdf_url"
                                   [href]="charge.receipt_pdf_url"
                                   target="_blank"
                                   class="inline-flex items-center text-[#0061ff] font-inter text-[12px] font-[500] mt-1 hover:text-[#2f75e7] transition-colors">
                                    <mat-icon class="icon-size-4 mr-1" [svgIcon]="'mat_solid:download'"></mat-icon>
                                    Baixar Recibo
                                </a>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>